import prototype from './prototype';
import prototypeView from './prototypeView';

const bundle = {
  prototype,
  prototypeView,
};

export default bundle;
